// A place to put shared constants

export const LEXICON_URL = 'https://lexicon-production.herokuapp.com/update';
// export const LEXICON_URL = "http://localhost:3000/update"; // for editing locally
